import WideContainer from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { useWebp } from '@r1-frontend/shared/hooks/useWebp';

import DealerForm from '~/src/features/mania/components/DealerForm';
import { staticImagePath } from '~/src/features/mania/data';

import * as ST from './styled';

const DealerFormBlock = (): JSX.Element => {
    const currentFormPattern = useWebp() ? `${staticImagePath}/mask_pattern.webp` : `${staticImagePath}/mask_pattern.png`;

    return (
        <ST.FormSection>
            <WideContainer>
                <ST.FormBlock>
                    <DealerForm/>
                </ST.FormBlock>
                <ST.FormPatternBlock bgImg={currentFormPattern} data-test='form-pattern'/>
            </WideContainer>
        </ST.FormSection>
    );
};

export default DealerFormBlock;
